const shopify = {
  footerMessagePaymentVia: 'Payment via',
  inputCustomerName: 'Name',
  inputCardExpiryDate: 'Expiration Date',
  errorInsertCardExpiration: 'Please enter the expiration date of the card',
  errorCardExpired: 'Oops! The card you entered has expired',
  errorInvalidExpirationDate: 'Expiration date is invalid',
  inputCardNumber: 'Card number',
  inputCardSecurityCode: 'Security code (CVV)',
  greeting: 'Hi, {customerName}',
  fillCardSecurityCode: 'Fill in the card\'s security code',
  invalidSecurityCode: 'Invalid security code',
  invalidCvv: 'Invalid security code',
  fillColombianAddress: 'Fill in the address input.',
  invalidColombianAddress: 'Invalid address.',
};

module.exports = shopify;
